// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { ReactElement, useContext } from "react";

import styled from "@emotion/styled";
import { ThemeContext, Theme } from "../../../theme/provider/theme-provider";

const StyledTag = styled.span<Theme & Omit<TagProps, "children">>`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-block;
  height: auto;
  margin-right: 8px;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  cursor: default;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  ${(props) => `background-color:${props.color || props.colors.primary};
              color:${props.fontColor || props.colors.white};
              border:${
                props.borderColor ? `1px solid ${props.borderColor}` : "none"
              };`}
`;

interface TagProps {
  children: ReactElement;
  color?: string;
  fontColor?: string;
  borderColor?: string;
}

export const Tag = ({ children, ...props }: TagProps) => {
  const { theme } = useContext(ThemeContext);
  return (
    <StyledTag {...theme} {...props}>
      {children}
    </StyledTag>
  );
};
